var e = /* @__PURE__ */ ((f) => (f.agency = "agency", f.self = "self", f.offPlatform = "offPlatform", f))(e || {});
export {
  e as TALENT_DROPDOWN_VALUES
};
//# sourceMappingURL=TalentDropdown.types.es.js.map
